/**
 * Lê o cookie CSRF não-HttpOnly emitido por `apps/api/src/domain/owner-auth/cookies.ts`
 * (F02) para ecoar no header `x-csrf-token` em toda mutação (AMVP-03, double-submit
 * HMAC-bound). Os dois nomes possíveis (`__Host-argink_csrf` em HTTPS,
 * `argink_csrf_dev` em HTTP local) são os literais do backend — não inventar um
 * terceiro nome aqui. O token em si NÃO é segredo (é o par público do double-submit;
 * o servidor valida o HMAC), por isso é seguro lê-lo de `document.cookie` — mas ele
 * nunca é copiado para localStorage/sessionStorage.
 */
const CSRF_COOKIE_NAMES = ['__Host-argink_csrf', 'argink_csrf_dev'] as const;

export function readCsrfToken(): string | null {
  if (typeof document === 'undefined') return null;
  const cookies = document.cookie.split(';').map((part) => part.trim());
  for (const name of CSRF_COOKIE_NAMES) {
    const prefix = `${name}=`;
    const match = cookies.find((c) => c.startsWith(prefix));
    if (match) {
      try {
        return decodeURIComponent(match.slice(prefix.length));
      } catch {
        return null;
      }
    }
  }
  return null;
}
